export default __webpack_public_path__ + "static/media/translator-screenshot-02.e542c0e4.png";